export default __webpack_public_path__ + "static/media/ic16-close.82c2ab5e.svg";